import React, { useState } from 'react'


import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { Button, TextField } from '@material-ui/core'
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';

import { dateInputValue } from '../dates'
import { periodError } from '../reminder'
import { blockSign, nonNegativeChange } from '../../Root/nonNegative'

function EditNotification(props) {
  // Своя копия полей: то, что ввёл человек, не попадает в store, пока он не нажал «Сохранить».
  const [form, setForm] = useState(() => ({
    period: props.notification.period,
    noticeOn: dateInputValue(props.notification.noticeOn),
  }))
  // Что не так с периодом: показывается, когда человек вышел из поля или нажал «Сохранить».
  const [periodProblem, setPeriodProblem] = useState('')

  return (
    <Grid component={Paper} container spacing={3}>
      <Grid item xs={6}>
        <Typography variant={'h5'} align={'center'}>
          Уведомления
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <FormControl fullWidth>
          {/* Вернуться к блоку без сохранения: введённое не уходит ни на сервер, ни в store. */}
          <Button variant="outlined" disabled={props.saving} onClick={props.editAction}>Назад</Button>
        </FormControl>
      </Grid>
      <Grid item xs={3}>
        <FormControl fullWidth>
          <Button variant="outlined" color="primary" disabled={props.saving}
            onClick={()=>{
              const problem = periodError(form.period)
              if (problem) {
                setPeriodProblem(problem)
                return
              }
              // Форма закрывается, когда сервер ответил успехом: если не удалось, введённое остаётся.
              Promise.resolve(props.updateAction({ ...props.notification, ...form, period: Number(form.period), companyId: props.companyId })).then((result) => {
                if (!result || !result.error) props.editAction()
              })
            }}>Сохранить</Button>
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <TextField
          type="number"
          label="Периодичность в днях"
          value={form.period}
          variant="outlined"
          inputProps={{ min: 1, step: 1, onKeyDown: blockSign }}
          error={Boolean(periodProblem)}
          helperText={periodProblem}
          onChange={nonNegativeChange(e => {
            setForm({ ...form, period: e.target.value })
            setPeriodProblem('')
          })}
          onBlur={e => setPeriodProblem(periodError(e.target.value))}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id="date"
          label="Напомнить в"
          type="date"
          value={form.noticeOn}
          variant="outlined"
          onChange={e => setForm({ ...form, noticeOn: e.target.value })}
        />

      </Grid>
    </Grid>
  )
}

export default EditNotification
